export const between = (min, max, value) => Math.min(max, Math.max(min, value));
export const easeOutQuad = t => t * (2 - t);
